export enum LocaleCompatibility {
  EXACT_MATCH = 10,
  GOOD_MATCH = 5,
  POOR_MATCH = 1,
  NO_MATCH = 0
}